<template>
  <div>
  
    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <template v-if="offers !== null && offers.length > 0">
      <offer
        v-for="offer in offers"
        :key="calcOfferKey(offer)"
        :offer="offer"
      />
    </template>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import Offer from './PlayerOffer.vue';

import { OFFER_TYPE_SIMPLE   } from '../model/offer';
import { OFFER_TYPE_PERSONAL } from '../model/offer';

export default {
  name: 'PlayerOffers',

  components: {
    LoadingIndicator,
    Offer,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      isLoading: false,
      offers: null,
    };
  },

  computed: {
    message() {
      if(this.offers !== null && this.offers.length === 0) {
        return 'No offers.';
      }
      return null;
    },
  },

  created() {
    this.isLoading = true;

    const url = `/player/${this.playerId}/offers`;
    HTTP.get(url)
    .then(response => {
      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      this.offers = data;
    })
    .catch(e => {
      notifier.showError(e.response.data);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },

  methods: {
    calcOfferKey(offer) {
      switch(offer.type) {
        case OFFER_TYPE_SIMPLE:   return 's' + offer.protoId;
        case OFFER_TYPE_PERSONAL: return 'p' + offer.id;
      }
      //console.error(`Unknown offer type ${offer.type}.`);
      return null;
    },
  },
};
</script>
